function ProductCard({ product }) {
    return (
        <div className='w-full rounded-xl overflow-hidden bg-[#232327]'>
            <div className="w-full aspect-square">
                <img className='size-full object-cover' src={product?.productImgUrls[0]} alt="" />
            </div>
        </div>
    );
}

export default ProductCard;
